import React, { useEffect, useState } from 'react'
import MainLoader from './components/MainLoader'
import { Button, Card, CardContent, Grid, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import Sidebar from './components/Sidebar'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from 'react-router'
import i18next from 'i18next';
import noDataFound from "../src/assests/images/no-report-ic.svg";
import { postApi } from './api/services';
import { gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import moment from 'moment';
import CircleIcon from '@mui/icons-material/Circle';
import SyncIcon from '@mui/icons-material/Sync';
import imgurl from './assests/images/imgurl';
import inProcessIcon from "../src/assests/images/no-report-ic.gif";
import { useSelector } from 'react-redux';
import HomeIcon from '@mui/icons-material/Home';

const PrescriptionList = () => {

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [isRotating, setIsRotating] = useState(false);

  const locale = useSelector((state) => state.language.langData)

  useEffect(() => {
    getPrescription()
    // Set interval to run every 60 seconds
    // const intervalId = setInterval(() => {
    //   handleRotate();
    // }, 120000); // every 120000 = 2 minute prescriptions will get synced

    // // Cleanup interval when component unmounts
    // return () => clearInterval(intervalId);
  }, [])

  const getPrescription = async () => {
    const userObj = JSON.parse(localStorage.getItem('user_obj'))
    try {
      setIsLoading(true)
      let params = {
        // user_id: 141
        user_id: userObj.user_id
      }
      console.log("get_user_prescriptions params", params);
      const res = await postApi('get_user_prescriptions', params)
      if(res){
        console.log("get_user_prescriptions res", res);
        await trackEvent('prescription_list_viewed', 'success', '', localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('prescription_list_viewed', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
        setDataList(res?.prescriptions)
        setIsLoading(false)
      }
    } catch (err) {
      console.log("err", err);
      await trackEvent('prescription_list_viewed', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
      await gTagTracking('prescription_list_viewed', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno'),
        user_id: userObj.user_id
      })
      setIsLoading(false)
      serviceDown()
    }
  }

  const openPrescription = (e, data) => {
    navigate('/userprescription', {state: {prescription: data}})
  }

  const handleExplore = (e) => {
    e.stopPropagation()
    let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
    let url = `https://shop.alopexia.com/products/alopexia-hair-restoration-medicine?phone=${encrypted}`;
    window.open(url, "_self");
  }

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const handleRotate = () => {
    setIsRotating(true);  
    getPrescription()
  };

  const proceedToNxt = async (e, prescription) => {
    const userObj = JSON.parse(localStorage.getItem('user_obj'))
    e.stopPropagation()
    await trackEvent('explored_treatment', 'success', "", localStorage.getItem('phno'), userObj.user_id)
    await gTagTracking('explored_treatment', {
      action: 'success',
      error: '',
      mobile_number: localStorage.getItem('phno'),
      user_id: userObj.user_id
    })
    // let urlParams = encryptPhoneNum(`userid=${localStorage.getItem('user_id')}&prescription=${prescription.prescription_number}`)
    // let encrypted = encryptPhoneNum(localStorage.getItem('user_id'))
    // let encryptedPrescriptionNum = encryptPhoneNum(prescription.prescription_number)
    // let url = `https://centabiolab.com/checkout/?add-to-cart=64&userid=${encrypted}&prescription=${encryptedPrescriptionNum}`;
    // let subUrl = JSON.parse(sessionStorage.getItem('checkUser'))?.user_id?.woocommerce_customer_id ? "https://centabiolab.com/my-account/" : "https://centabiolab.com/register/"
    // let url = `${subUrl}?${urlParams}`;
    let url = `https://centabiolab.com/`;
    window.open(url, "_blank");
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className="photo-container main-section-container prescription-page">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          {/* <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate('/reports')}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid> */}
          <Grid
            item
            xs={11}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Prescriptions")}
            </Typography>
          </Grid>
          {/* <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid> */}
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {
          dataList?.length > 0 ? 
            <div className='prescription_main_holder'>
              {
                dataList.map((data) => {
                  return(
                    <div 
                      className={data.status === "valid" ? "prescriptionCard cursor-pointer" : "prescriptionCard cursor-pointer disabled"}
                      key={data.prescription_id}
                      onClick={(e) => data.status === "valid" && openPrescription(e, data)}
                    >
                      <Grid container spacing={2} className="prescriptionCardMain">
                        <Grid container spacing={2} className="prescriptionCardMain">
                          <Grid item xs={2} className="iconContainer">
                            <img src={imgurl.prescriptionIcon} className="prescriptionIcon"/>
                          </Grid>
                          <Grid item xs={7} className="prescriptionInfo">
                            <p className="mb-0 prescriptionId">{`${i18next.t("Dr")}. ${data?.doctor_name}`}</p>
                            <p className="mb-0 prescriptionDate">{`${i18next.t("Prescription ID")}: ${data?.prescription_number}`}</p>
                            <p className="mb-0 prescriptionDate">{`${moment(data?.prescription_date).format("LL")}`}</p>
                          </Grid>
                          <Grid item xs={3} className="prescriptioninfodiv">
                            {
                              data.status != "valid" ?
                                <div className="expired">
                                  <Typography >
                                    {i18next.t("Expired")}
                                  </Typography> 
                                </div>
                                  :
                                <div className="active">
                                  <Typography >
                                    {i18next.t("Active")}
                                  </Typography> 
                                </div>
                            }
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} className="prescriptionCardMain prescriptionAccessDiv">
                          <Grid item xs={12} className="prescriptionInfo">
                            <Button 
                              className='commonButton prescriptionAccessBtn mb-0'
                              onClick={(e) => proceedToNxt(e, data)}
                            >
                              {i18next.t(
                                locale === 'en' ?
                                  "Access Prescription - Only Treatment" :
                                locale === 'fr' ?
                                  "Accéder au traitement sur prescription médicale " :
                                locale === 'es' ?
                                  "Acceder al tratamiento con prescripción médica " :
                                "Access Prescription - Only Treatment"
                              )}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  )
                })
              }
            </div> 
              :
            <>
              <div className='prescription_main_holder nodata'>
                <div className="prescriptionCard nodata cursor-pointer mb-10px">
                  <Grid container spacing={2} className="prescriptionCardMain">
                    <Grid item xs={2} className="iconContainer">
                      <img src={inProcessIcon} className="prescriptionIcon"/>
                    </Grid>
                    <Grid item xs={10} className="prescriptionInfo">
                      <p className="mb-0 prescriptionId">{`${i18next.t("Your prescription will be available post review by our doctors, the standard wait time is 2-3 hours.")}`}</p>
                      {/* <p className="mb-0 prescriptionId">{`${i18next.t("Prescription will be processed in 2-3 hours")}`}</p> */}
                    </Grid>
                  </Grid>
                </div>
                <div className='d-flex justify-content-center align-items-center flex-direction-column noteDiv'>
                  <p className='text-left'>
                    <span className='p-head'>{i18next.t("Note")}:</span> {i18next.t("You'll receive an email with a login link once your prescription is ready.")}
                  </p>
                </div>
              </div>
              {
                !dataList &&
                <Button 
                  onClick={() => {
                    navigate(`/${localStorage.getItem('channel') === 'alopexia-ads' ? 'c1' : 'start-test'}`)
                    localStorage.clear()
                  }}
                  className='commonButton homebutton mt-20px'
                >
                  {i18next.t("Go to Home")}<HomeIcon className='ml-10px'/>
                </Button>
              }
            </>    
        }
      </div>
    </>
  )
}

export default PrescriptionList